import { createRouter, createWebHistory } from 'vue-router';
import { setupRouterGuards } from './guards';

// 静态引入所有页面组件
import HomePage from '../pages/HomePage.vue';
import LoginPage from '../pages/LoginPage.vue';
import SubAppWrapperPage from '../pages/SubAppWrapperPage.vue';
import Page404 from '../pages/404.vue';

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
      meta: {
        title: '首页',
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: {
        title: '登录',
        requiresAuth: false
      }
    },
    {
      path: '/sub-app/userManage/:catchAll(.*)*',
      name: 'userManage',
      component: SubAppWrapperPage,
      meta: {
        title: '用户管理',
        requiresAuth: true,
        subApp: 'userManage' // 添加子应用标识
      },
      props: route => ({
        app: 'userManage',
        subPath: route.params.catchAll || ''
      })
    },
    {
      path: '/sub-app/officerCare/:catchAll(.*)*',
      name: 'officerCare',
      component: SubAppWrapperPage,
      meta: {
        title: '干休所',
        requiresAuth: true,
        subApp: 'officerCare'
      },
      props: route => ({
        app: 'officerCare',
        subPath: route.params.catchAll || ''
      })
    },
    {
      path: '/sub-app/educationCare/:catchAll(.*)*',
      name: 'educationCare',
      component: SubAppWrapperPage,
      meta: {
        title: '社区居家智慧养老平台',
        requiresAuth: true,
        subApp: 'educationCare'
      },
      props: route => ({
        app: 'educationCare',
        subPath: route.params.catchAll || ''
      })
    },
    {
      path: '/sub-app/gtzhyl/:catchAll(.*)*',
      name: 'gtzhyl',
      component: SubAppWrapperPage,
      meta: {
        title: '居家及社区智慧养老平台',
        requiresAuth: true,
        subApp: 'gtzhyl'
      },
      props: route => ({
        app: 'gtzhyl',
        subPath: route.params.catchAll || ''
      })
    },
    {
      path: '/sub-app/homeCare/:catchAll(.*)*',
      name: 'homeCare',
      component: SubAppWrapperPage,
      meta: {
        title: '居家养老',
        requiresAuth: true,
        subApp: 'homeCare'
      },
      props: route => ({
        app: 'homeCare',
        subPath: route.params.catchAll || ''
      })
    },
    // 保留通用路由作为后备
    {
      path: '/sub-app/:app/:catchAll(.*)*',
      name: 'subApp',
      component: SubAppWrapperPage,
      meta: {
        title: '子应用',
        requiresAuth: true
      },
      props: route => ({
        app: route.params.app,
        subPath: route.params.catchAll || ''
      })
    },
    {
      path: '/404',
      name: '404',
      component: Page404,
      meta: {
        title: '页面不存在',
        requiresAuth: false
      }
    },
    {
      path: '/:catchAll(.*)',
      redirect: '/404'
    }
  ]
});

// 设置路由守卫
setupRouterGuards(router);

export default router;
